import { createE2EKanbifyClient } from '../test/e2eMockClient'
import { createShimClient } from './shimClient'

const useE2EMocks = import.meta.env.VITE_E2E_MOCKS === 'true'
// Kanbify is shim-only. There is intentionally no external backend fallback here:
// local, live, and deploy builds must all talk to the same-origin Express shim.
const shimUrl = import.meta.env.VITE_SHIM_URL || ''

export const kanbify = useE2EMocks
  ? createE2EKanbifyClient()
  : createShimClient(shimUrl)
